import React from 'react';
import { Card } from "react-bootstrap";
import face_tamas_ormandi from "../../assets/img/face_tamas_ormandi.png";
import ShowMoreText from "react-show-more-text";
import proj_vehicle_scheduling from "../../assets/img/proj_vehicle_scheduling.png";

const Tamas_Ormandi_vehicle_scheduling = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_vehicle_scheduling} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_tamas_ormandi}
              /* this will be the text on the banner */
              alt="Mixed-Integer Linear Programming for Coordinated Vehicle Scheduling at Highway Bottlenecks"
            />{" "}
            <p className="text7">Tamás Ormándi</p>
            <br />
            <p className="text8">
              PhD student{" "}
            </p>
            <p className="text8">BME Traffic Lab</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Cooperative lane merging at highway bottlenecks requires coordinated scheduling to
            maintain continuous traffic flow and prevent shockwaves. Representing the roadway via
            discrete space-time reservation cells enables conflict-free slot allocation through V2X
            communication. The task is to formulate a Mixed-Integer Linear Programming (MILP) model
            that determines optimal vehicle speeds, headways, and lane-change timings. The
            optimization must maximize overall traffic throughput while satisfying kinematic safety and
            comfort constraints.
            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                <a href="https://research.polyu.edu.hk/en/publications/an-integrated-approach-to-optimal-merging-sequence-generation-and/">Chen, J., Zhou, Y., & Chung, E. (2023). 
                An Integrated Approach to Optimal Merging Sequence Generation and Trajectory Planning of Connected Automated 
                Vehicles for Freeway On-Ramp Merging Sections. IEEE Transactions on Intelligent Transportation Systems, 1-16. Article 10268666. </a>
                </li>
                <li>
                <a href="https://www.sciencedirect.com/science/article/pii/S0191261525001420">Chen, J., Wu, Y., Zhou, Y., Chung, E., & Wang, S. (2025).
                Solving connected automated vehicle merging problems: A generalized benders decomposition-based approach for mixed-integer nonlinear programming. 
                Transportation Research Part B: Methodological, 200, 103293. doi:10.1016/j.trb.2025.103293</a>
                </li>
            </ul>
            

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Tamas_Ormandi_vehicle_scheduling;